module.exports = __webpack_public_path__ + "static/media/game.84e69db8.svg";